import { createMigration } from './utils';

export const migrationTo9_203 = createMigration({
    migrateVideo(video) {
        return video.withMutations(map => {
            map.get('slides').forEach((scene, i) => {
                map.setIn(['slides', i], this.migrateScene(scene));
            });
        });
    },
    migrateScene(scene, isSceneDesign) {
        if (!isSceneDesign) {
            return scene;
        }
        return scene.withMutations(map => {
            // update siemens_energy and siemens_energy_2022 scene designs
            if (map.get('sceneDesign').startsWith('siemens_energy')) {
                const newChildren = map.get('children', [])
                    .filter(child => {
                        return !(child.get('name').endsWith('_embedded_logo')
                            || child.get('name').endsWith('_disable_swap'));
                    });
                map.set('children', newChildren);
            }
        });
    },
});
